import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";
import { getGroupsStatus } from '../../dashboard/dashboardSlice';
import { getUserColor } from '../../../utils/index';
import WhiteStarIcon from "./svgs/whiteStartIcon";

function RewardsSummary() {
  useDisableBrowserBack();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  let { cookieGameId } = useReadCookies();

  const groups = useSelector((state) => state.dashboard.groupStatus);

   // animations
   let titleRef = useRef(null);
   let rewardsContainerRef = useRef(null);
   let controlbarRef = useRef(null);
 
   const [animation, setAnimation] = useState(null);

  useEffect(()=> {
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#292929');

    dispatch(getGroupsStatus(cookieGameId));

    setAnimation(gsap.timeline()
      .fromTo(controlbarRef, { opacity: 1, y: 300}, {opacity: 1, y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(titleRef, { opacity: 1, y: -800}, {y: 0, opacity: 1, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(rewardsContainerRef, { opacity: 1, y: -800}, {opacity: 1, y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
    );

  }, []);

  const getRandomPosition = () => {
    if(rewardsContainerRef){
      const containerWidth = rewardsContainerRef.offsetWidth;
      const containerHeight = rewardsContainerRef.offsetHeight;
  
      const divSize = ((Math.random() * 100) + 50).toFixed();
      const top = (Math.random() * (containerHeight - divSize)).toFixed();
      const left = (Math.random() * (containerWidth - divSize)).toFixed();
      return {size: divSize, top: top, left: left};
    }
    return {size: 0, top: 0, left: 0};

  }

  const getRandomSize = () => {
    let difference = 100 - 50;
    let scaleFactor = Math.random();
    scaleFactor = Math.floor( scaleFactor * difference);
    scaleFactor = scaleFactor + 50;
    let size = 90 * scaleFactor / 100;
    return size;
  }

  const getRandomOrder = () => {
    return Math.round(Math.random() * (50 - 0));
  }

  const handleContinueButton = (e) => {
    e.preventDefault();

    animation
      .fromTo(titleRef, { y: 0}, {opacity: 1, y: -800, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(rewardsContainerRef, { y: 0}, {y: -800, opacity: 1, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(controlbarRef, { opacity: 1, y: 0}, {opacity: 0, y: 300, duration: 0.5, ease: Elastic.easeOut(1, 0.3), onComplete: () => {
        navigate("/app/game/end" + window.location.search);
    }});

  }

  return (
    <div className="mobile-container rewards-summary-screen" >
      <div className="content-wrapper">
        <h3 className="title" ref={ e => { titleRef = e }}>{t("student.rewards_overview.message")}</h3>
        <div className="rewards" ref={e => { rewardsContainerRef = e }}>
          <ul>
            { groups && groups.map(group =>(
              group.players && group.players.map(player => {
                const position = getRandomPosition();
                const size = getRandomSize();
                return(
                <li key={player.id} style={{ order: getRandomOrder() }}>
                  <div className="avatar" >
                    <img src={`/storage/avatar/group_${group.group_id}.png`} width={`${size}`} height={`${size}`} style={{ borderColor: getUserColor(player.secret)}} />
                  </div>
                </li>
                )
              }
            )))}
            { Array.from(Array(10), (e, i) => {
              const position = getRandomPosition();
              return (
                <li key={i} style={{ order: getRandomOrder() }}>
                  <div className="reward">
                    <WhiteStarIcon />
                  </div>
                  
                </li>
              )
            }
            )}
          </ul>
        </div>
      </div>
      <div className="control-panel" ref={ e => { controlbarRef = e }}>
        <a className={`back visibility-hidden`} href="">
        <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1.5L3 10.5L12 19.5" stroke="white" strokeWidth="4"/>
        </svg>
        </a>
        <a href="" className={`continue-button`} onClick={handleContinueButton}>
          <div className="label">{t("student.rewards_overview.button_text")}</div>
          <div className="arrow">
            <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 1.5L11 10.5L2 19.5" stroke="white" strokeWidth="4"/>
            </svg>
          </div>
        </a>
      </div>
    </div>
  );
} 

export default RewardsSummary;